













































































































































































































































































































































































































































































import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';

import { AccountModule } from '@/store/modules/account';
import { GetUserInfo } from '../api/login';
import { GetCity, GetDistrict, GetProvinces, getObsToken } from '../api/common/index';
import { MESSAGE_CENTER_REFRESH_EVENT } from '../api/message-center';
import { GetSkuCategoryOptions, SKU_CATEGORY_TYPE, SkuCategoryTreeItem } from '../api/sku-category';
import {
  ApplyCurrentScSupplierSkuJd,
  CreateCurrentScSupplierSku,
  DeleteCurrentScSupplierSku,
  ExportSupplierScSkuFavorite,
  GetCurrentScSupplierDetail,
  GetCurrentScSupplierSkuList,
  GetSupplierScSkuFavoritePage,
  GetSupplierScSkuFavoriteStats,
  UpdateCurrentScSupplier,
} from '../api/sc/index';

type AreaOption = {
  code: string;
  name: string;
};

type DeviceFormItem = {
  localId: string;
  modelName: string;
  quantity: number;
};

type SupplierDeviceResult = {
  id: string;
  brandName: string;
  modelName: string;
  quantity: number;
};

type SupplierSkuResult = {
  id: string;
  sn: string;
  description: string;
  sizeText: string;
  materialText: string;
  craftText: string;
  imageUrl: string;
  firstCategoryCode: string;
  firstCategoryName: string;
  secondCategoryCode: string;
  secondCategoryName: string;
  referencePrice: string;
  approvalStatus: number;
  approvalStatusName: string;
};

type FavoriteManageRecord = {
  itemType: 'SC_SKU' | 'SC_SYNC_PRODUCT';
  targetSn: string;
  supplierEnterpriseSn: string;
  supplierName: string;
  skuSn?: string;
  name?: string;
  description?: string;
  sizeText: string;
  materialText: string;
  craftText: string;
  imageUrl: string;
  firstCategoryCode: string;
  firstCategoryName: string;
  secondCategoryCode: string;
  secondCategoryName: string;
  referencePrice: string;
  studioName?: string;
  proofNotice?: string;
  minQuantity?: number;
  stepQuantity?: number;
  favoriteCount: number;
  previousFavoriteCount: number;
  trendType: string;
  trendText: string;
};

type FavoriteStats = {
  totalFavoriteCount: number;
  favoritedTargetCount: number;
  newFavoriteCount: number;
  topTargetName: string;
};

function normalizeArray<T>(value: T[] | null | undefined): T[] {
  return Array.isArray(value) ? value : [];
}

function createDeviceRow(device?: Partial<DeviceFormItem>): DeviceFormItem {
  return {
    localId: `${Date.now()}_${Math.random()}`,
    modelName: device && device.modelName ? device.modelName : '',
    quantity: device && device.quantity ? device.quantity : 1,
  };
}

@Component({
  components: {},
})
export default class SupplyChainApply extends Vue {
  activeStep = 1;
  pageLoading = false;
  submitLoading = false;
  favoriteLoading = false;
  favoriteExportLoading = false;
  favoriteSkuDrawerVisible = false;
  favoriteSkuDrawerSize = '480px';
  acceptImgType = '.png,.PNG,.jpg,.JPG,.jpeg,.JPEG,.webp,.WEBP';

  logoUploadServer = '';
  logoUploadPayload = {};
  skuUploadServer = '';
  skuUploadPayload = {};

  provinceOptions: AreaOption[] = [];
  cityOptions: AreaOption[] = [];
  districtOptions: AreaOption[] = [];
  skuCategoryTree: SkuCategoryTreeItem[] = [];
  secondCategoryOptions: SkuCategoryTreeItem[] = [];
  skuList: SupplierSkuResult[] = [];
  favoriteRecords: FavoriteManageRecord[] = [];
  favoritePageNum = 1;
  favoritePageSize = 10;
  favoriteTotal = 0;
  favoriteSkuDetail: FavoriteManageRecord | null = null;
  favoriteStats: FavoriteStats = {
    totalFavoriteCount: 0,
    favoritedTargetCount: 0,
    newFavoriteCount: 0,
    topTargetName: '',
  };
  hasPendingScSupplierApply = false;

  enterpriseForm = {
    name: '',
    logoUrl: '',
    provinceCode: '',
    cityCode: '',
    districtCode: '',
    address: '',
    phone: '',
    supplierIntro: '',
    supplierMainProducts: '',
    inviteCode: '',
    bpSn: '',
    tagCodeList: [] as string[],
    deviceList: [createDeviceRow()],
  };

  skuForm = {
    description: '',
    sizeText: '',
    materialText: '',
    craftText: '',
    imageUrl: '',
    firstCategoryCode: '',
    secondCategoryCode: '',
    referencePrice: '',
  };

  favoriteFilters = {
    keyword: '',
    firstCategoryCode: '',
    secondCategoryCode: '',
    dateRange: [] as string[],
    sortType: 'favoriteCountDesc',
  };

  validateSupplierQualificationCode = (rule: any, value: string, callback: any) => {
    if (!this.hasSupplierQualificationCode()) {
      callback(new Error('VIP邀请码或星云验证码至少填写一个'));
      return;
    }
    callback();
  };

  enterpriseFormRules = {
    name: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
    provinceCode: [{ required: true, message: '请选择省份', trigger: 'change' }],
    cityCode: [{ required: true, message: '请选择城市', trigger: 'change' }],
    supplierIntro: [{ required: true, message: '请输入公司描述', trigger: 'blur' }],
    supplierMainProducts: [{ required: true, message: '请输入主营产品', trigger: 'blur' }],
    inviteCode: [{ validator: this.validateSupplierQualificationCode, trigger: 'blur' }],
    bpSn: [{ validator: this.validateSupplierQualificationCode, trigger: 'blur' }],
  };

  skuFormRules = {
    description: [{ required: true, message: '请输入产品描述', trigger: 'blur' }],
    firstCategoryCode: [{ required: true, message: '请选择一级分类', trigger: 'change' }],
    secondCategoryCode: [{ required: true, message: '请选择二级分类', trigger: 'change' }],
    imageUrl: [{ required: true, message: '请上传产品图', trigger: 'change' }],
  };

  @Watch('$route', { immediate: true })
  async onRouteChange() {
    this.syncActiveStep();
    if (!this.isScSupplier) {
      return;
    }
    if (this.activeStep === 3) {
      await this.fetchFavoriteManage(1);
      return;
    }
    if (this.activeStep === 2) {
      await this.fetchSkuList();
    }
  }

  async mounted() {
    this.syncFavoriteDrawerSize();
    window.addEventListener('resize', this.syncFavoriteDrawerSize);

    if (!AccountModule.isLogined) {
      this.$message.warning('请先登录后再申请入驻');
      this.$router.replace('/login');
      return;
    }
    this.pageLoading = true;
    try {
      await this.syncUserInfo();
      await Promise.all([this.fetchProvinceOptions(), this.fetchSupplierDetail(), this.fetchCategoryOptions()]);
      if (this.activeStep > 1 && !this.isScSupplier) {
        this.$message.warning('供应商资质审核通过后可上架商品');
        this.goStep(1);
        return;
      }
      if (this.isScSupplier && this.activeStep === 3) {
        await this.fetchFavoriteManage(1);
      } else if (this.isScSupplier && this.activeStep === 2) {
        await this.fetchSkuList();
      }
    } finally {
      this.pageLoading = false;
    }
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.syncFavoriteDrawerSize);
  }

  get isScSupplier() {
    const isSc = (AccountModule.currentUserInfo || {}).isSc;
    return isSc === true || isSc === 'true' || isSc === 1 || isSc === '1';
  }

  get enterpriseSubmitButtonText() {
    if (!this.isScSupplier && this.hasPendingScSupplierApply) {
      return '审核中';
    }
    return this.isScSupplier ? '下一步：上架商品SKU' : '提交供应商审核';
  }

  get isEnterpriseSubmitDisabled() {
    return !this.isScSupplier && this.hasPendingScSupplierApply;
  }

  get favoriteSecondCategoryOptions() {
    const firstCategory = this.skuCategoryTree.find(item => item.code === this.favoriteFilters.firstCategoryCode);
    return firstCategory && Array.isArray(firstCategory.children) ? firstCategory.children : [];
  }

  async syncUserInfo() {
    try {
      const userInfo = await GetUserInfo();
      userInfo && (await AccountModule.setUserInfo(userInfo));
    } catch (error) {
      return;
    }
  }

  syncActiveStep() {
    const routeStep = Number((this.$route.query.step as string) || 1);
    const routeView = (this.$route.query.view as string) || '';
    if (routeStep === 2 && routeView === 'favorite') {
      this.activeStep = 3;
      this.$router.replace({
        path: '/supplyChainApply',
        query: { step: '3' },
      });
      return;
    }
    this.activeStep = routeStep === 3 ? 3 : routeStep === 2 ? 2 : 1;
  }

  async fetchProvinceOptions() {
    try {
      const res = await GetProvinces();
      this.provinceOptions = normalizeArray<AreaOption>(res);
    } catch (error) {
      this.provinceOptions = [];
    }
  }

  async fetchSupplierDetail() {
    const detail = await GetCurrentScSupplierDetail();
    if (!detail) {
      return;
    }

    this.enterpriseForm.name = detail.name || '';
    this.enterpriseForm.logoUrl = detail.logoUrl || '';
    this.enterpriseForm.provinceCode = detail.provinceCode || '';
    this.enterpriseForm.cityCode = detail.cityCode || '';
    this.enterpriseForm.districtCode = detail.districtCode || '';
    this.enterpriseForm.address = detail.address || '';
    this.enterpriseForm.phone = detail.phone || '';
    this.enterpriseForm.supplierIntro = detail.supplierIntro || '';
    this.enterpriseForm.supplierMainProducts = detail.supplierMainProducts || '';
    this.enterpriseForm.inviteCode = detail.inviteCode || '';
    this.enterpriseForm.bpSn = detail.bpSn || '';
    this.enterpriseForm.tagCodeList = normalizeArray<string>(detail.selectedTagCodeList);
    this.hasPendingScSupplierApply = detail.hasPendingScSupplierApply === true;
    const deviceList = normalizeArray<SupplierDeviceResult>(detail.deviceList).map(item =>
      createDeviceRow({
        modelName: item.modelName || '',
        quantity: item.quantity || 1,
      })
    );
    this.enterpriseForm.deviceList = deviceList.length ? deviceList : [createDeviceRow()];

    if (this.enterpriseForm.provinceCode) {
      await this.fetchCityOptions(this.enterpriseForm.provinceCode);
    }
    if (this.enterpriseForm.cityCode) {
      await this.fetchDistrictOptions(this.enterpriseForm.cityCode);
    }
  }

  async fetchSkuList() {
    try {
      const res = await GetCurrentScSupplierSkuList();
      this.skuList = normalizeArray<SupplierSkuResult>(res);
    } catch (error) {
      this.skuList = [];
    }
  }

  buildFavoriteQuery(pageNum = this.favoritePageNum) {
    const dateRange = Array.isArray(this.favoriteFilters.dateRange) ? this.favoriteFilters.dateRange : [];
    return {
      keyword: this.favoriteFilters.keyword || undefined,
      firstCategoryCode: this.favoriteFilters.firstCategoryCode || undefined,
      secondCategoryCode: this.favoriteFilters.secondCategoryCode || undefined,
      startDate: dateRange[0] || undefined,
      endDate: dateRange[1] || undefined,
      sortType: this.favoriteFilters.sortType,
      pageNum,
      pageSize: this.favoritePageSize,
    };
  }

  async fetchFavoriteManage(pageNum = this.favoritePageNum) {
    this.favoriteLoading = true;
    try {
      const query = this.buildFavoriteQuery(pageNum);
      const [statsRes, pageRes] = await Promise.all([GetSupplierScSkuFavoriteStats(query), GetSupplierScSkuFavoritePage(query)]);
      this.favoriteStats = {
        totalFavoriteCount: Number((statsRes && statsRes.totalFavoriteCount) || 0),
        favoritedTargetCount: Number((statsRes && (statsRes.favoritedTargetCount || statsRes.favoritedSkuCount)) || 0),
        newFavoriteCount: Number((statsRes && statsRes.newFavoriteCount) || 0),
        topTargetName: (statsRes && (statsRes.topTargetName || statsRes.topSkuName)) || '',
      };
      this.favoritePageNum = Number((pageRes && pageRes.current) || pageNum);
      this.favoritePageSize = Number((pageRes && pageRes.size) || this.favoritePageSize);
      this.favoriteTotal = Number((pageRes && pageRes.total) || 0);
      this.favoriteRecords = normalizeArray<any>(pageRes && pageRes.records)
        .map(item => ({
          ...item,
          itemType: item.itemType || 'SC_SKU',
          targetSn: item.targetSn || item.skuSn || '',
          name: item.name || item.description || '',
        }))
        .filter(item => item.itemType === 'SC_SKU' || item.itemType === 'SC_SYNC_PRODUCT');
    } catch (error) {
      this.favoriteRecords = [];
      this.favoriteTotal = 0;
    } finally {
      this.favoriteLoading = false;
    }
  }

  async fetchCategoryOptions() {
    try {
      const res = await GetSkuCategoryOptions(SKU_CATEGORY_TYPE.JD_ECO);
      this.skuCategoryTree = normalizeArray<SkuCategoryTreeItem>(res);
      this.syncSecondCategoryOptions(true);
    } catch (error) {
      this.skuCategoryTree = [];
      this.secondCategoryOptions = [];
    }
  }

  async fetchCityOptions(code: string) {
    try {
      const res = await GetCity({ code });
      this.cityOptions = normalizeArray<AreaOption>(res);
    } catch (error) {
      this.cityOptions = [];
    }
  }

  async fetchDistrictOptions(code: string) {
    try {
      const res = await GetDistrict({ code });
      this.districtOptions = normalizeArray<AreaOption>(res);
    } catch (error) {
      this.districtOptions = [];
    }
  }

  async handleProvinceChange() {
    this.enterpriseForm.cityCode = '';
    this.enterpriseForm.districtCode = '';
    this.cityOptions = [];
    this.districtOptions = [];
    if (!this.enterpriseForm.provinceCode) {
      return;
    }
    await this.fetchCityOptions(this.enterpriseForm.provinceCode);
  }

  async handleCityChange() {
    this.enterpriseForm.districtCode = '';
    this.districtOptions = [];
    if (!this.enterpriseForm.cityCode) {
      return;
    }
    await this.fetchDistrictOptions(this.enterpriseForm.cityCode);
  }

  addDevice() {
    this.enterpriseForm.deviceList.push(createDeviceRow());
  }

  removeDevice(index: number) {
    this.enterpriseForm.deviceList.splice(index, 1);
    if (!this.enterpriseForm.deviceList.length) {
      this.enterpriseForm.deviceList.push(createDeviceRow());
    }
  }

  buildDevicePayload() {
    return this.enterpriseForm.deviceList
      .map((item, index) => ({
        brandName: 'Epson',
        modelName: item.modelName.trim(),
        quantity: item.quantity || 1,
        sequence: index,
      }))
      .filter(item => item.modelName);
  }

  hasSupplierQualificationCode() {
    return Boolean(this.enterpriseForm.inviteCode.trim() || this.enterpriseForm.bpSn.trim());
  }

  async handleSaveEnterprise() {
    if (this.isEnterpriseSubmitDisabled) {
      this.$message.warning('供应商审核中，请勿重复提交');
      return;
    }
    const formRef = this.$refs.enterpriseFormRef as any;
    if (!formRef) {
      return;
    }
    formRef.validate(async (valid: boolean) => {
      if (!valid) {
        return;
      }
      this.submitLoading = true;
      try {
        await UpdateCurrentScSupplier({
          ...this.enterpriseForm,
          inviteCode: this.enterpriseForm.inviteCode.trim(),
          bpSn: this.enterpriseForm.bpSn.trim(),
          tagCodeList: this.enterpriseForm.tagCodeList || [],
          deviceList: this.buildDevicePayload(),
        });
        await this.syncUserInfo();
        if (this.isScSupplier) {
          this.$message.success('企业信息已保存');
          this.goStep(2);
          return;
        }
        this.hasPendingScSupplierApply = true;
        this.$message.success('供应商资料已提交审核，审核通过后可上架商品SKU');
      } finally {
        this.submitLoading = false;
      }
    });
  }

  resetSkuForm() {
    this.skuForm = {
      description: '',
      sizeText: '',
      materialText: '',
      craftText: '',
      imageUrl: '',
      firstCategoryCode: '',
      secondCategoryCode: '',
      referencePrice: '',
    };
    this.secondCategoryOptions = [];
    const formRef = this.$refs.skuFormRef as any;
    formRef && formRef.resetFields();
  }

  handleSkuFirstCategoryChange() {
    this.syncSecondCategoryOptions(true);
  }

  syncSecondCategoryOptions(resetInvalid = false) {
    const firstCategory = this.skuCategoryTree.find(item => item.code === this.skuForm.firstCategoryCode);
    this.secondCategoryOptions = firstCategory && Array.isArray(firstCategory.children) ? firstCategory.children : [];
    if (
      resetInvalid &&
      this.skuForm.secondCategoryCode &&
      !this.secondCategoryOptions.some(item => item.code === this.skuForm.secondCategoryCode)
    ) {
      this.skuForm.secondCategoryCode = '';
    }
  }

  async handleCreateSku() {
    const formRef = this.$refs.skuFormRef as any;
    if (!formRef) {
      return;
    }
    formRef.validate(async (valid: boolean) => {
      if (!valid) {
        return;
      }
      this.submitLoading = true;
      try {
        if (!this.isScSupplier) {
          this.$message.warning('供应商资质审核通过后可上架商品');
          return;
        }
        await CreateCurrentScSupplierSku({ ...this.skuForm });
        await this.fetchSkuList();
        this.resetSkuForm();
        this.$message.success('商品已上架');
      } finally {
        this.submitLoading = false;
      }
    });
  }

  async handleDeleteSku(item: SupplierSkuResult) {
    await this.$confirm('确认删除该商品吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    });
    await DeleteCurrentScSupplierSku({ sn: item.sn });
    await this.fetchSkuList();
    this.$message.success('删除成功');
  }

  async prepareUpload(file: any, target: 'logo' | 'sku') {
    const suffix = file.type.split('/')[1];
    const res = await getObsToken({ suffix });
    const payload = {
      key: res.key,
      policy: res.policy,
      signature: res.signature,
      AccessKeyId: res.accessid,
      success_action_status: '200',
    };
    file.originalUrl = res.cdn + res.key;

    if (target === 'logo') {
      this.logoUploadServer = res.host;
      this.logoUploadPayload = payload;
      return;
    }

    this.skuUploadServer = res.host;
    this.skuUploadPayload = payload;
  }

  async handleLogoBeforeUpload(file: any) {
    await this.prepareUpload(file, 'logo');
  }

  async handleSkuBeforeUpload(file: any) {
    await this.prepareUpload(file, 'sku');
  }

  handleLogoUploadSuccess(res: any, file: any) {
    this.enterpriseForm.logoUrl = file.raw.originalUrl;
  }

  handleSkuUploadSuccess(res: any, file: any) {
    this.skuForm.imageUrl = file.raw.originalUrl;
  }

  goStep(step: number) {
    if (step > 1 && !this.isScSupplier) {
      this.$message.warning('供应商资质审核通过后可上架商品');
      return;
    }
    const targetQuery = step === 1 ? {} : { step: String(step) };
    const currentStep = Number((this.$route.query.step as string) || 1);
    if (currentStep === step && !this.$route.query.view) {
      return;
    }
    this.$router.push({
      path: '/supplyChainApply',
      query: targetQuery,
    });
  }

  handleFavoriteFirstCategoryChange() {
    this.favoriteFilters.secondCategoryCode = '';
    this.handleFavoriteSearch();
  }

  handleFavoriteSearch() {
    this.fetchFavoriteManage(1);
  }

  handleFavoritePageChange(page: number) {
    this.fetchFavoriteManage(page);
  }

  handleViewFavoriteSku(item: FavoriteManageRecord) {
    if (!item || !item.targetSn) {
      return;
    }
    this.favoriteSkuDetail = { ...item };
    this.favoriteSkuDrawerVisible = true;
  }

  handleFavoriteDrawerClosed() {
    this.favoriteSkuDetail = null;
  }

  syncFavoriteDrawerSize() {
    this.favoriteSkuDrawerSize = window.innerWidth <= 640 ? '100%' : '480px';
  }

  formatDetailValue(value: string | number | null | undefined) {
    if (value === 0) {
      return '0';
    }
    if (value === undefined || value === null) {
      return '--';
    }
    const text = String(value).trim();
    return text || '--';
  }

  displayFavoriteName(item: FavoriteManageRecord) {
    return item.name || item.description || '未填写商品名称';
  }

  getItemTypeLabel(itemType: string) {
    return itemType === 'SC_SYNC_PRODUCT' ? '微喷体验商品' : '供应链 SKU';
  }

  async handleFavoriteExport() {
    this.favoriteExportLoading = true;
    try {
      await ExportSupplierScSkuFavorite(this.buildFavoriteQuery(this.favoritePageNum));
    } catch (error) {
      this.$message.error((error as Error).message || '导出失败');
    } finally {
      this.favoriteExportLoading = false;
    }
  }

  handleBackToList() {
    this.$router.push('/supplyChain');
  }

  async handleJdEntry() {
    await ApplyCurrentScSupplierSkuJd();
    window.dispatchEvent(new Event(MESSAGE_CENTER_REFRESH_EVENT));
    this.$message.success('申请已提交，请前往消息中心查看');
  }

  getApprovalStatusLabel(status: number) {
    if (status === 1) {
      return '已通过';
    }
    if (status === 2) {
      return '已驳回';
    }
    return '审核中';
  }

  getApprovalStatusClass(status: number) {
    if (status === 1) {
      return 'sku-status-success';
    }
    if (status === 2) {
      return 'sku-status-danger';
    }
    return 'sku-status-warning';
  }

  buildCategoryText(item: SupplierSkuResult | FavoriteManageRecord) {
    const values = [item.firstCategoryName, item.secondCategoryName].filter(Boolean);
    return values.length ? values.join(' / ') : '未设置分类';
  }
}
